import classNames from 'classnames';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { Table } from '../../../components';
import { COURSE_BY_STUDENT_STATUS, CREDIT_APPLICATION_STATUS, DATE_YMD } from '../../../core/configs/constants';
import { useQuery, useStore } from '../../../core/utils/hook';
import moment from 'moment';

const CourseListByStudent = observer(() => {

    // params, query
    const { id } = useParams();
    const query = useQuery();
    const status = query.get('status');

    // store
    const { groupAdminStore: { getCourseListByStudent, courseListByStudent } } = useStore();

    // state
    const { register, watch } = useForm({ defaultValues: { status: status ? Number(status) : COURSE_BY_STUDENT_STATUS.ALL.key } });

    const watchStatus = watch('status');

    // lifecycle
    useEffect(() => {
        getCourseListByStudent(id, { status: watchStatus });
    }, [watchStatus, id])

    // columns
    const columns = [
        {
            Header: 'No.',
            accessor: '',
            disableSortBy: true,
            Cell: ({ row: { original, index } }) => {
                return (
                    <div>
                        {index + 1}
                    </div>
                );
            },
            width: '60'
        },
        {
            Header: '講座名',
            accessor: 'name',
            disableSortBy: true,
            Cell: ({ row: { original } }) => {
                return (
                    <div>
                        <Link to={`/course/${original?.courseId}`}>{original?.name}</Link>
                    </div>
                );
            },
            width: '200'
        },
        {
            Header: '受講コード',
            accessor: 'attendanceCode',
            disableSortBy: true,
            Cell: ({ row: { original } }) => {
                return (
                    <p>
                        {original?.attendanceCode}
                    </p>
                );
            },
            width: '120'
        },
        {
            Header: '講座受講開始日',
            accessor: 'coursePeriodStart',
            disableSortBy: true,

            Cell: ({ row: { original } }) => {
                return (
                    <div>
                        {original?.coursePeriodStart ? moment(original.coursePeriodStart).format(DATE_YMD) : null}
                    </div>
                );
            },
            width: '160'
        },
        {
            Header: '受講終了日',
            accessor: 'coursePeriodEnd',
            disableSortBy: true,

            Cell: ({ row: { original } }) => {
                return (
                    <div>
                        {original?.coursePeriodEnd ? moment(original.coursePeriodEnd).format(DATE_YMD) : null}
                    </div>
                );
            },
            width: '160'
        },
        {
            Header: '受講率',
            accessor: 'attendanceRate',
            disableSortBy: true,

            Cell: ({ row: { original } }) => {
                return (
                    <div>
                        {original?.attendanceRate ? original?.attendanceRate > 100 ? 100 : original?.attendanceRate : 0}%
                    </div>
                );
            },
            width: '115'
        },
        {
            Header: '初回正答率',
            accessor: 'achievementAverage',
            disableSortBy: true,

            Cell: ({ row: { original } }) => {
                return (
                    <div>
                        {original?.achievementAverage !== null ? `${Math.floor(original?.achievementAverage)}%` : ''}
                    </div>
                );
            },
            width: '115'
        },
        {
            Header: 'ステータス',
            accessor: 'status',
            disableSortBy: true,

            Cell: ({ row: { original } }) => {
                // eslint-disable-next-line max-len
                const key = Object.keys(COURSE_BY_STUDENT_STATUS).filter(e => COURSE_BY_STUDENT_STATUS[e].value?.includes(original?.status))?.[0] ?? null;
                return (
                    <div>
                        <div className={classNames(
                            key !== null ?
                                COURSE_BY_STUDENT_STATUS[key].key === COURSE_BY_STUDENT_STATUS.USER_COURSE_ATTENDING.key 
                                    ? 'course-attending'
                                    : COURSE_BY_STUDENT_STATUS[key].key === COURSE_BY_STUDENT_STATUS.USER_COURSE_COMPLETE.key
                                        ? 'course-completed'
                                        : ''
                                : ''
                        )}>
                            {
                                key !== null &&
                                COURSE_BY_STUDENT_STATUS[key].label
                            }
                        </div>
                    </div>
                );
            },
            width: '115'
        },
        {
            Header: '単位申請状況',
            accessor: '',
            disableSortBy: true,

            Cell: ({ row: { original } }) => {
                return (
                    <div>
                        {
                            original?.isNonCertificate ? '-' :
                                CREDIT_APPLICATION_STATUS.COMPLETED.value.includes(original?.status) ? 
                                    original?.isAppliedCert ?
                                        CREDIT_APPLICATION_STATUS.COMPLETED.label
                                        : CREDIT_APPLICATION_STATUS.NO_APPLY.label
                                    : CREDIT_APPLICATION_STATUS.NOT_COMPLETED.label
                        }
                    </div>
                );
            },
            width: '120'
        }
    ]

    return (
        <div className='row mg-t-20'>
            <div className='col-md-12 col-sm-12 col-12'>
                <div className='filter-2 mg-t-0'>
                    <span> ステータス</span> <select {...register('status')}>
                        {
                            Object.keys(COURSE_BY_STUDENT_STATUS).filter(key => !COURSE_BY_STUDENT_STATUS[key].noSearch).map(e => 
                                <option key={COURSE_BY_STUDENT_STATUS[e].key} 
                                    value={COURSE_BY_STUDENT_STATUS[e].key}>{COURSE_BY_STUDENT_STATUS[e].label}</option>)
                        }
                    </select>
                </div>
            </div>
            <div className='col-md-12 col-sm-12 col-12'>
                <Table
                    columns={columns}
                    data={courseListByStudent?.listCourse || []}
                    disablePaging={true}
                    disableSelectionPageSize={true}
                    scrollHorizontalWidth={'1400px'}
                    className='lst-attendance-table mg-t-35'
                />
            </div>
        </div>
    );
});

export default CourseListByStudent;
